import { createContext, useContext } from "react";

/**
 * Registry of slot name -> placeholder DOM element. The dock shell measures the
 * active slot's element and overlays itself on top of it.
 */
export const DockSlotsContext = createContext(null);

export function useDockSlots() {
  const ctx = useContext(DockSlotsContext);
  if (!ctx) {
    throw new Error("useDockSlots must be used inside DockSlotsProvider");
  }
  return ctx;
}
